import { Keys } from "../const.js";
import { catalog } from "../data/catalog.js";
import { createElement } from "../utils/render.js";
import AbstractView from "./abstract.js";
import Slider from "./slider.js";

const createSliderMarkup = (list) => {
  const listMap = list.map((item) => {
    const { code, images, text, logoImages, title, link } = item;
    const codeText = code ? `<div class="slider__item-promo-code">Промокод на скидку 10%<div class="slider__item-code"><span>WOMANHIT</span></div></div>` : ``;
    const imageMarkup = link
      ? `<a class="slider__item-link" href="${link}" target="_blank" rel="noopener noreferrer">
          <img class="slider__item-image" src="${images}" alt="">
      </a>`
      : `<img class="slider__item-image" src="${images}" alt="">`;
    const logoImagesMarkup = logoImages ? `<img class="slider__logo " src="${logoImages}" alt="" height="24">` : ``;

    return (
      `<li class="slider__item">
				<div class="slider__header">
					<div class="slider__header-logo"><img src="${logoImages}"></div>
				</div>

        ${imageMarkup}

        <h3 class="slider__item-title">${title}</h3>
        <p class="slider__item-description">${text}</p>

        ${codeText}
      </li>`
    );
  }).join(`\n`);

  return (`<ul class="slider__list">${listMap}</ul>`);
};

const createDotsMarkup = (list) => {
  const createDotsMarkup = list
    .map(() => {
      return (`
        <li class="slider__slide-changer-item">
          <button class="slider__slide-changer-dot" type="button" aria-label="Перейти к слайду номер 2"></button>
        </li>
      `);
    }).join(`\n`);
  return (
    `<ul class="slider__slide-changer">${createDotsMarkup}</ul>`
  );
};

const popupMarkup = (filterItem, selectedSector) => {
  const listShow = Object.values(catalog[selectedSector])
  //.filter((item) => item.filter.indexOf(filterItem) >= 0);
  const sliderMarkup = createSliderMarkup(listShow);
  const dotsMarkup = createDotsMarkup(listShow);

  return (
    `<div class="spinner__gift-slider slider slider_open content__slider_start">
			<h2 class="slider__title">Идеальный подарок на 23 февраля для <span>${filterItem}</span> мужчины</h2>
			<div class="slider__up-icon"><img src="img/arrow_up.png"></div>
      ${sliderMarkup}
      ${dotsMarkup}
			<div class="slider__control">
			<button class="slider__slide slider__slide_prev" aria-label="Листать в начало" tabindex="-1"><</button>
			<button class="slider__slide slider__slide_next" aria-label="Листать в конец" tabindex="-1">></button>
		</div>
    </div>`
  );
};

const Popup = class extends AbstractView {
  constructor(siteBodyElement, filterItem, selectedSector) {
    super();
    this._siteBodyElement = siteBodyElement;
    this._closePopupHandler = this._closePopupHandler.bind(this);
    this._filterItem = filterItem;
    this._selectedSector = selectedSector;
    setTimeout(() => {
      this._sliderComponent = new Slider(siteBodyElement);
    }, 1000);
  }

  init() {
  }

  getTemplate() {
    return popupMarkup(this._filterItem, this._selectedSector);
  }

  getElement() {
    if (!this._element) {
      this._element = createElement(this.getTemplate());
    }

    return this._element;
  }

  removeElement() {
    this._element = null;
  }

  showSliderPopup(event) {
    event.preventDefault();
    if (this.root.classList.contains(`slider_open`)) {
      this._closeSliderPopup(event);
    } else {
      this._siteBodyElement.classList.add(`popup-open`);
      this.root.classList.add(`slider_open`);
      document.addEventListener(`keydown`, this._escKeyDownHandler);
    }
  }

  _closeSliderPopup(event) {
    event.preventDefault();
    document.removeEventListener(`keydown`, this._escKeyDownHandler);
    this._siteBodyElement.classList.remove(`popup-open`);
    this.root.classList.remove(`slider_open`);
  }

  _escKeyDownHandler(event) {
    console.log(`close popup`);
    if (event.key === Keys.ESC || event.key === Keys.ESCAPE) {
      event.preventDefault();
      this.showSliderPopup(event);
    }
  }

  _closePopupHandler(event) {
    event.preventDefault();
    this._callback.closePopup();
  }

  setClosePopupHandler(callback) {
    this._callback.closePopup = callback;
    //this.getElement().querySelector(`.slider__button-close`).addEventListener(`click`, this._closePopupHandler);
  }
};

export default Popup;
